package de.emgress.baskets.modules.schedule

import androidx.compose.runtime.*
import core.constants.TextKeys
import core.enums.EActivityStateDB
import core.utils.TimeUtils
import de.emgress.baskets.core.enums.EIconButton
import de.emgress.baskets.core.extensions.isMobile
import de.emgress.baskets.core.styles.Styles
import de.emgress.baskets.modules.components.GameDayInformation
import de.emgress.baskets.modules.components.IconButton
import dtos.games.outgoing.GameInfoDTOOut
import dtos.sponsor.SponsorDTOOut
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.datetime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun ScheduleItem(
    mGame: GameInfoDTOOut,
    mSponsor: SponsorDTOOut?,
    mIndex: Int,
    mIsLastGame: Boolean,
    mIsNextGame: Boolean,
    mShowCountdown: Boolean,
) {

    val mPeriodeToNextGame by produceState<DateTimePeriod?>(null, mGame, mShowCountdown) {
        val gameTimestamp = Instant.fromEpochMilliseconds(mGame.mDateAndTime)
        while (mShowCountdown) {
            value = Clock.System.now().periodUntil(gameTimestamp, TimeZone.currentSystemDefault()) //TODO TimeZone.of("Europe/Berlin") crashes in js target
            delay(1000)
        }
    }

    val mIsActiveGame by produceState(false, mGame) {
        value = mGame.mActivityState == EActivityStateDB.ACTIVE
    }

    if(mIsLastGame) {
        Div({
            id(TextKeys.SCHEDULE_SCROLL_ID)
        })
    }

    Div({
        classes(Styles.cssClasses.flexboxContainer)
    }) {
        Div({
            classes(Styles.cssClasses.flexboxItem, Styles.cssClasses.gameComponent)
        }) {
            Div({
                classes(Styles.cssClasses.column)
            }) {
                if (window.isMobile()) {
                    Div({
                        classes(Styles.cssClasses.flexboxContainer, Styles.cssClasses.marginSmall)
                        style {
                            justifyContent(JustifyContent.Center)
                        }
                    }) {
                        GameDayInformation(mIndex.plus(1), mGame, true)
                    }
                }
                Div({
                    classes(Styles.cssClasses.rowCentered)
                    style {
                        alignItems(AlignItems.Stretch)
                        paddingRight(8.px)
                        paddingLeft(8.px)
                        width(100.percent - 16.px)
                    }
                }) {
                    TeamComponent(mGame.mHomeTeamName, mGame.mHomeLogoUrl, true)

                    GameMetadata(mGame, mIndex.plus(1))

                    TeamComponent(mGame.mGuestTeamName, mGame.mGuestLogoUrl, false)
                }

                mPeriodeToNextGame?.let {
                    Countdown(it)
                }

                if (mIsLastGame) {
                    mSponsor?.let {
                        ScheduleSponsor(mSponsor)
                    }
                }
            }
        }
        
        Div({
            classes(Styles.cssClasses.flexboxItem)
            style {
                minWidth(250.px)
            }
        }) {
            Div({
                classes(Styles.cssClasses.rowCentered)
            }) {
                if(mIsNextGame || mIsActiveGame) {
                    IconButton("Im Liveticker ansehen", mGame.mLiveStreamUrl, EIconButton.APP_LIVETICKER)
                }
                if(mIsLastGame && !mIsActiveGame) {
                    IconButton("Highlights ansehen", mGame.mLiveStreamUrl, EIconButton.APP_LIVETICKER)
                }
                if(mGame.mDateAndTime < Clock.System.now().toEpochMilliseconds()) {
                    IconButton("Re-Live", mGame.mLiveStreamUrl, EIconButton.SPORTDEUTSCHLAND_TV)
                }
                if (mIsNextGame) {
                    IconButton("Livestream", mGame.mLiveStreamUrl, EIconButton.SPORTDEUTSCHLAND_TV)
                }
            }
        }
    }
}